export default __webpack_public_path__ + "locales/pt-BR/SingleSignOn.json?hash=328279a5cae0d5fc4fbaed2d1e155eee";